import { IsPositive, IsString, MinLength } from 'class-validator'
import { positiveError } from './common'

export class CreateLeaveWizard {
  @IsString({ message: 'Name is invalid' })
  @MinLength(3, { message: 'Name is too short' })
  public name!: string

  @IsPositive({ message: positiveError })
  public principal_partner!: number

  @IsPositive({ message: positiveError })
  public managing_partner!: number

  @IsPositive({ message: positiveError })
  public tax_partner!: number

  @IsPositive({ message: positiveError })
  public audit_partner!: number

  @IsPositive({ message: positiveError })
  public business_development_partner!: number

  @IsPositive({ message: positiveError })
  public hr_manager!: number

  @IsPositive({ message: positiveError })
  public employee!: number

  constructor() {
    this.name = ''
    this.principal_partner = 0
    this.managing_partner = 0
    this.tax_partner = 0
    this.audit_partner = 0
    this.business_development_partner = 0
    this.hr_manager = 0
    this.employee = 0
  }
}
